import React, { useEffect, useRef } from 'react'
import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { BottomNextButton } from "components/common/BottomNextButton";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import onboarding_lock from "static/image/onboarding/onboarding_lock.png";
import useIsInappWebview from "hooks/useIsInappWebview";
import { useMutation } from '@tanstack/react-query'
import { onboardingApi } from '../../../../api/onboardingApi'
import { extractHexColor } from "../../../../styles/hexOpacity";
import { sendMessage } from "../../../../utils/webview";

export default function Openness_7() {
  const navigate = useNavigate();
  const isInappWebview = useIsInappWebview();

  const handleNext = () => {
    navigate(`/onboarding_new/result/1`);
  };

  const handleAppLockSettings = () => {
    navigate(`/applock-setup`, { state: { redirectTo: `/onboarding_new/result/1` } });
  }

  const pageKey = "openness_7";

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
  });

  useEffect(() => {
    if (isInappWebview) {
      const topBackground = extractHexColor(
        theme.vars.palette.Background.SoftHighlight
      );
      const bottomBackground = extractHexColor(
        theme.vars.palette.Background.SoftHighlight
      );

      if (topBackground && bottomBackground) {
        sendMessage(
          JSON.stringify({
            event: "set_safearea_color",
            params: {
              topColor: `${topBackground}`,
              bottomColor: `${bottomBackground}`,
            },
          })
        );
      }
    }
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          지금부터 이곳은 나만의 공간이 됩니다.
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          앱에 비밀번호를 설정해 내 정보를 더 안전하게 보호할 수 있습니다.
        </CustomTypography>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={onboarding_lock}
            alt={"onboarding"}
            style={{
              maxWidth: "264px",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <Box
        sx={{
          // 화면 하단에 고정
          position: "fixed",
          left: "50%",
          transform: "translateX(-50%)",
          bottom: 0,
          width: "100%",
          maxWidth: "660px",
          zIndex: 1200,
          px: "20px",
          py: 2,
          display: 'flex', // flexbox 사용
          justifyContent: 'center', // 가로 가운데 정렬
          gap: 1,
        }}
      >
        <Button
          variant={"Outlined"}
          size={"md"}
          sx={{
            height: "54px",
            width: "50%",
            fontWeight: 700,
          }}
          // disabled={disabled}
          onClick={() => handleNext()}
        >
          {"다음에 하기"}
        </Button>
        <Button
          variant={"Action"}
          size={"md"}
          sx={{
            height: "54px",
            width: "50%",
            fontWeight: 700,
          }}
          // disabled={disabled}
          onClick={() => handleAppLockSettings()}
        >
          {"비밀번호 설정하기"}
        </Button>
      </Box>
    </Box>
  );
}